export default __webpack_public_path__ + "static/media/enkawhite.b83fdd9f.svg";